import React from 'react';
import { Alert, List } from 'antd';

export default function FollowUpsPanel({ followUps = [] }) {
  if (followUps.length === 0) return null;

  return (
    <Alert
      type="warning"
      showIcon
      message={`${followUps.length} credential(s) referenced in the document but not present — these will NOT be created`}
      description={
        <List
          size="small"
          dataSource={followUps}
          renderItem={(f) => (
            <List.Item>
              {/* Minor (final review): the pre-wizard table showed the
                  username alongside the name (e.g. "Domain Admin
                  (svc-backup)") — restore that here now that this panel is
                  the only place these follow-ups surface. */}
              <strong>{f.name}{f.username ? ` (${f.username})` : ''}</strong>
              <span>{f.evidence}</span>
            </List.Item>
          )}
        />
      }
    />
  );
}
